import { render, staticRenderFns } from "./PracticeCreate.vue?vue&type=template&id=8b53660e"
import script from "./PracticeCreate.vue?vue&type=script&lang=js"
export * from "./PracticeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports